<template>
  <b-card title="Measurements" header-class="font-weight-bold" body-class="measurements-card">
    <table class="table">
      <tbody>
        <tr>
          <td style="width:50%">
            <strong>Phase 1</strong>
          </td>
          <td>
            {{this.isNumeric(rms_voltage_l1) ? rms_voltage_l1+' V' : ''}}
          </td>
          <td v-bind:class="current_phase_class(rms_current_l1, isASingleOrThreePhaseDevice)" v-b-tooltip :title="showTooltip(isASingleOrThreePhaseDevice)">
            {{this.isVoltageAndCurrentDevice ? (this.isNumeric(rms_current_l1) ? rms_current_l1+' A' : '' ) : "N/A"}}
          </td>
        </tr>
        <tr>
          <td style="width:50%">
            <strong>Phase 2</strong>
          </td>
          <td v-bind:class="voltage_phase_class(rms_voltage_l2, isASinglePhaseDevice)" v-b-tooltip :title="showTooltip(isASinglePhaseDevice)">
             {{this.isAThreePhaseDeviceOrVoltageAndCurrent ? (this.isNumeric(rms_voltage_l2) ? rms_voltage_l2+' V' : '') : "N/A"}}
          </td>
          <td v-bind:class="current_phase_class(rms_current_l2, isASingleOrThreePhaseDevice)" v-b-tooltip :title="showTooltip(isASingleOrThreePhaseDevice)">
            {{this.isVoltageAndCurrentDevice ? (this.isNumeric(rms_current_l2) ? rms_current_l2+' A' : '') : "N/A"}}
          </td>
        </tr>
        <tr>
          <td style="width:50%">
            <strong>Phase 3</strong>
          </td>
          <td>
            {{this.isNumeric(rms_voltage_l3) ? rms_voltage_l3+' V' : ''}}
          </td>
          <td v-bind:class="current_phase_class(rms_current_l3, isASingleOrThreePhaseDevice)" v-b-tooltip :title="showTooltip(isASingleOrThreePhaseDevice)">
            {{this.isVoltageAndCurrentDevice ? (this.isNumeric(rms_current_l3) ? rms_current_l3+' A' : '') : "N/A"}}
          </td>
        </tr>
      </tbody>
    </table>
    <CardTimestampFooter v-bind:timestamp="timestamp"/>
  </b-card>
</template>
<script>
import CardTimestampFooter from '@/components/Device/CardTimestampFooter/CardTimestampFooter';

const THREE_PHASE = 'Three Phase';
const SINGLE_PHASE = 'Single Phase';
const VOLTAGE_AND_CURRENT = 'Voltage & Current';
export default {
  name: 'MeasurementsCard',
  components: {CardTimestampFooter},
  props: ['rms', 'pole'],
  computed: {
    rms_current_l1(){
      return  this._props.rms && this._props.rms.current && this.isNumeric(this._props.rms.current.L1) ? this._props.rms.current.L1: '';
    },
    rms_current_l2(){
      return  this._props.rms && this._props.rms.current && this.isNumeric(this._props.rms.current.L2) ? this._props.rms.current.L2 : '';
    },
    rms_current_l3(){
      return  this._props.rms && this._props.rms.current && this.isNumeric(this._props.rms.current.L3) ? this._props.rms.current.L3 : '';
    },
    rms_voltage_l1(){
      return  this._props.rms && this._props.rms.voltage && this.isNumeric(this._props.rms.voltage.L1) ? this._props.rms.voltage.L1 : '';
    },
    rms_voltage_l2(){
      return  this._props.rms && this._props.rms.voltage && this.isNumeric(this._props.rms.voltage.L2) ? this._props.rms.voltage.L2 : '';
    },
    rms_voltage_l3(){
      return  this._props.rms && this._props.rms.voltage && this.isNumeric(this._props.rms.voltage.L3) ? this._props.rms.voltage.L3 : '';
    },
    timestamp(){
      return this._props.rms && this._props.rms.timestamp ? this._props.rms.timestamp : null;
    },
    isAThreePhaseDeviceOrVoltageAndCurrent() {
      let poleTypes = [THREE_PHASE, VOLTAGE_AND_CURRENT, null]
      return (this._props.pole == null) || (poleTypes.includes(this._props.pole.type))
    },
    isASinglePhaseDevice() {
      return this._props.pole && this._props.pole.type == SINGLE_PHASE;
    },
    isASingleOrThreePhaseDevice() {
      let pole_types = [SINGLE_PHASE, THREE_PHASE]
      return (this._props.pole && pole_types.includes(this._props.pole.type))
    },
    isVoltageAndCurrentDevice() {
      let pole_types = [VOLTAGE_AND_CURRENT, null]
      return (this._props.pole == null) || (pole_types.includes(this._props.pole.type))
    },
  },
  methods: {
    voltage_phase_class(value, phase){
      return {
        '': !this.isNumeric(value),
        'greyed-box': this.isNumeric(value) && phase,
      };
    },
    current_phase_class(value, phase){
      return {
        '': !this.isNumeric(value),
        'greyed-box': this.isNumeric(value) && phase,
      };
    },
    showTooltip(phase) {
      if(phase) {
        return "Value is not relevant to '" + this._props.pole.type + "'";
      }
      return "";
    }
  }
}
</script>
<style src="./MeasurementsCard.scss" lang="scss" scoped/>
